<template>
  <div>
    <div class="comond_btn">
      <el-button  @click="handleEdit(0, null)" >添加角色</el-button>
    </div>
    <template>
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="createBy"
          label="创建人"
          width="">
        </el-table-column>
        <el-table-column
          label="创建时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.createTime) }}</div>
           </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="角色(英文标识)">
        </el-table-column>
        <el-table-column
          prop="description"
          label="描述">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
        </el-table-column>
        <el-table-column
          prop="isFinal"
          label="修改">
        </el-table-column>
        <el-table-column
          prop="updateBy"
          label="更新人">
        </el-table-column>
         <el-table-column
          label="更新时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.updateTime) }}</div>
           </template>
        </el-table-column>
        <el-table-column
          width="240"
          label="操作选项">
           <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(2, scope.row)">修改权限</el-button>
            <!-- <el-button  
              size="mini"
              @click="handleEdit(1, scope.row)">编辑</el-button> -->
            <!-- <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="30%"
        center>
        <el-form :model="form" :rules="rules">
          <el-form-item label="角色(英文)" :label-width="formLabelWidth" v-if="sts !== 2" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
           <el-form-item label="描述" :label-width="formLabelWidth" v-if="sts !== 2" prop="description">
            <el-input v-model="form.description"></el-input>
          </el-form-item>
          <el-form-item label="能否修改" :label-width="formLabelWidth" v-if="sts !== 2">
            <el-select v-model="form.isFinal" placeholder="请选择">
              <el-option label="是" value='true'></el-option>
              <el-option label="否" value='false'></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="sts === 2">
            <div class="modlerole">
              <div>
                <div class="changerole" v-for="(n, index) in modelList" :class="currentIndex === index? 'isactive': ''" :key="n.key" @click="searchmodel(n, index)">
                   {{ n.name }} 
                    <el-checkbox  v-for="nn in n.permissionDtos" :key="nn.key" :checked="nn.userPermissionId !== 0 ? true: false" @change="changerole(nn)"><span>{{nn.name}}</span></el-checkbox>
                </div>
              </div>
              <!-- <div v-if="isshow === true">
                <div v-for="nn in modelroleList" :key="nn.key">
                  <el-checkbox :checked="nn.userPermissionId !== 0 ? true: false" @change="changerole(nn)"><span>{{nn.name + nn.userPermissionId}}</span></el-checkbox>
                  <input type="checkbox" :checked="nn.userPermissionId !== 0 ? true: false" @change="changerole(nn)"/><span>{{nn.name }}</span>
                </div>
              </div> -->
            </div>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button  @click="handleexit(sts)">取消</el-button>
          <el-button type="primary" @click="handlesuccess(sts)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { queryrole, addRole, modulequeryModule, modulequeryModuleIdPermission, rolequeryPermissionRoldId, roleaddRolePermission, rolecancelRolePermission, rolecancelOrAddRolePermission } from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
export default {
  data () {
    return {
      list: [],
      centerDialogVisible: false,
      form: { //  新增初始化form
      },
      modelList: [], //  模块列表
      modelroleList: [], //  模块下的权限列表
      formLabelWidth: '120px',
      sts: 0, //  0 添加, 1 编辑 2 编辑权限
      title: '', //  添加窗口标题
      currentroleid: '', //  当前角色id
      currentmoudleid: '', //  当前模块id
      currentpermissionDtosid: '', //  当前权限id
      currentuserPermissionId: '', //  当前角色和权限关系主键
      isshow: false,
      currentIndex: 0,
      rules: {
        name: [
          { type: 'string', required: true, message: '请输入角色名', trigger: 'blur' },
        ],
        description: [
          { type: 'string', required: true, message: '请输入角色描述', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    searchmodel (n, index) {
      console.log(n)
      this.currentIndex = index
      this.isshow = true
      this.currentmoudleid = n.id
      this.modelroleList = []
      this.modelroleList = n.permissionDtos
    },
    changerole (n) {
      console.log(n)
      this.currentpermissionDtosid = n.id
      this.currentuserPermissionId = n.userPermissionId
      let para = new URLSearchParams()
      if (n.userPermissionId !== 0) {
        para.append('userPermissionId', this.currentuserPermissionId)
      }
      para.append('roleId', this.currentroleid)
      para.append('permissionId', this.currentpermissionDtosid)
      para.append('moduleId', this.currentmoudleid)
      rolecancelOrAddRolePermission(para).then(data => {
         if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
      this.getrolequeryPermissionRoldId(this.currentroleid)
    },
    getrolequeryPermissionRoldId (id) { //  角色查询权限
      let para = new URLSearchParams()
      para.append('roleId', id)
      rolequeryPermissionRoldId(para).then(data => {
        console.log(data)
        this.modelList = data.data
      })
    },
    handleEdit (ind, row) { //  编辑或者新增
      this.centerDialogVisible = true
      console.log(ind, row)
      if (ind === 1) {
        this.title = '编辑角色'
        this.form = row
        this.sts = 1
      } else if (ind === 0) {
        this.title = '新增角色'
        this.form = {}
        this.sts = 0
      } else if (ind === 2) {
        this.title = '修改权限'
        this.sts = 2
        this.currentroleid = row.id //  角色id
        this.getrolequeryPermissionRoldId(row.id)
      }
    },
    handlesuccess (sts) { //  提交修改信息
      if (sts === 0) {
        let para = new URLSearchParams()
        para.append('name', this.form.name)
        para.append('description', this.form.description)
        para.append('isFinal', this.form.isFinal)
        addRole(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getqueryrole()
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else if (sts === 2){
        //  修改权限
        this.isshow = false
        this.centerDialogVisible = false
      }
    },
    handleexit () {
      this.isshow = false
      this.centerDialogVisible = false
    },
    handleDelete (ind, row) { //  删除
      console.log(ind, row)
    },
    getqueryrole () { //  查询全部角色
      let params = qs.stringify({
        isValid: true
      })
      console.log(params)
      queryrole(params).then(data => {
        console.log(data)
        this.list = data.data
      })
    },
    old_getmodulequeryModule (v) { //  查询模块
      let para = new URLSearchParams()
      para.append('isValid', v)
      modulequeryModule(para).then( data => {
        console.log(data)
        this.modelList = data.data
      })
    },
    old_getmodulequeryModuleIdPermission (m, v) {//  根据id查询模块下的权限
      let para = new URLSearchParams()
      para.append('moduleId', m)
      para.append('isValid', v)
      modulequeryModuleIdPermission(para).then(data => {
        console.log(data)
        this.modelroleList = data.data
      })
    },
     formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
  },
  mounted () {
    this.getqueryrole()
  }
}
</script>
<style lang="stylus" scoped>
.comond_btn
  display flex
  justify-content flex-end
  margin-bottom 30px
  button
    background-color #0a3d5f
    color #fff
.modlerole
  display flex
  justify-content space-between
.isactive
  background-color #ccc
.isactive:before
  content ''
  display inline-block
  vertical-align middle
  height 44px
  width 2px
  background-color red
.changerole:hover
  cursor pointer
.changerole
  padding-right  15px
</style>
